var _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 763",
    width: 1280,
    height: 763,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 510,
    textAnchor: "middle",
    fontFamily: "Inter, Helvetica Neue, Arial, sans-serif",
    fontWeight: 700,
    fontSize: 280,
    fill: "#0F172A",
    letterSpacing: -10
  }, "bripple", /*#__PURE__*/React.createElement("tspan", {
    fill: "#2563FF"
  }, "x"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordmark);
export default __webpack_public_path__ + "static/media/wordmark.d5eede061d1fb3b6d3697ab345e1f7de.svg";
export { ForwardRef as ReactComponent };